// 数据看板
const databoard = {
    path: '/databoard',
    name: 'DataBoard',
    icon: '',
    redirect: '/databoard/deviceMonitor',
    component: () =>
        import('@/pages/layout/appMain'),
    children: [
        //设备监控
        {
            icon: 'el-icon-s-cooperation',
            name: 'DeviceMonitor',
            path: '/deviceMonitor',
            component: () =>
                import('@/pages/dataBoard/deviceMonitor/deviceMonitor.vue')
        },
        // 监测点
        {
            icon:'el-icon-s-help',
            name:'MonitoringPoint',
            path:'/monitoringPoint',
            component:()=>import('@/pages/dataBoard/MonitoringPoint/MonitoringPoint.vue')
        },
        // 监测点
        {
            icon:'el-icon-s-help',
            name:'Map',
            path:'/monitorMap',
            component:()=>import('@/pages/dataBoard/map/map.vue')
        },
        // 总览
        {
            icon:'el-icon-pie-chart',
            name:'overview',
            path:'/overview',
            component:()=>import('@/pages/dataBoard/overview/overview.vue')
        }

    ]
}

export default databoard
